import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-592d102d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { style: {"padding-top":"20px"} }
const _hoisted_3 = {
  style: {"position":"relative","bottom":"-4px"},
  class: "flex-ter"
}

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRoute } from 'vue-router'
import UploadFile from '@/components/common/UploadFilePDF.vue'
import { getConfigApi } from '@/apis/user'
import { QuestionFilled } from '@element-plus/icons-vue'

export default /*#__PURE__*/_defineComponent({
  props: ['templateList', 'zozotownConfig'],
  setup(__props, { expose }) {

const props = __props
const route = useRoute()


const form = ref({
  clubName: '',
  customerShopName: '',
  receiverName: '',
  brand: '',
  tagLogo: ''
})
const formRef = ref()

const rules = ref({
  clubName: [
    {
      required: true,
      message: t('会社名不能为空'),
      trigger: 'blur'
    }
  ],
  customerShopName: [
    {
      required: true,
      message: t('店铺名不能为空'),
      trigger: 'blur'
    }
  ],
  receiverName: [
    {
      required: true,
      message: t('收件人名不能为空'),
      trigger: 'blur'
    }
  ],
  brand: [
    {
      required: true,
      message: t('品牌不能为空'),
      trigger: 'blur'
    }
  ]
})

const validPackingList = async () => {
  if (route.params.sendType !== '4') {
    return true
  }
  const validPackingList = await formRef.value.validate()
  // const validLogo = await formLogo.value.validate()
  // console.log(validLogo, form)
  return validPackingList
}

const getPackingListData = () => {
  if (route.params.sendType === '4') {
    return {
      shopTagContent: {
        ...form.value
      }
    }
  }
  return {}
}

watch(() => props.zozotownConfig.tagLogo, (val) => {
  // form.value = {
  //   ...form.value,
  //   ...val
  // }
  form.value.tagLogo = val
})
const getZozotownConfig = async () => {
  // const res = await getConfigApi({
  //   configCode: 'DELIVERY_TAG_BASE_PARAM',
  //   level: 3
  // })
  // if (res.success) {
  //   form.value = {
  //     ...form.value,
  //     ...JSON.parse(res.data.configValue)
  //   }
  // }
  form.value = {
    ...form.value,
    ...props.zozotownConfig
  }
}

getZozotownConfig()

expose({
  validPackingList,
  getPackingListData
})


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_unref(route).params.sendType === '4')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            "label-width": "100px",
            "label-position": "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('纳品书明细')
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_unref(t)("纳品书明细")) + " ", 1),
                    _createVNode(_component_el_tooltip, {
                      content: _unref(t)('仓库打印纳品书时需要显示相关信息'),
                      placement: "top",
                      effect: "light"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(QuestionFilled))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    ref: (_value, _refs) => {
                      _refs['formRef'] = _value
                      formRef.value = _value
                    },
                    rules: rules.value,
                    "label-width": "100px",
                    model: form.value,
                    inline: true,
                    validateOnRuleChange: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('收件人名'),
                        prop: "receiverName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.value.receiverName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.receiverName) = $event)),
                            maxlength: "50",
                            style: {"width":"128px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('会社名'),
                        prop: "clubName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.value.clubName,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.clubName) = $event)),
                            maxlength: "50",
                            style: {"width":"128px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('店铺名'),
                        prop: "customerShopName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.value.customerShopName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.customerShopName) = $event)),
                            maxlength: "50",
                            style: {"width":"128px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('品牌'),
                        prop: "brand"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: form.value.brand,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.brand) = $event)),
                            maxlength: "50",
                            style: {"width":"128px"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["rules", "model"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _renderSlot(_ctx.$slots, "default")
      ]))
    : _createCommentVNode("", true)
}
}

})